import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./HeaderNavigate.scss";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { KEY_NAME } from "../../utils/KeyName";

const NO_SEARCH = "NO_SEARCH";

const HeaderNavigate = ({ label, to = "/ ", showFilter = false }) => {
  const navigate = useNavigate();
  const { get } = useCustomSearchParams();
  const {
    entityName,
    selectedFilterBy,
    selectedFilterByLabel,
    changeFilterByData,
    changeSelectedFilterBy,
    changeSelectedFilterByLabel,
    changeFilterBySearchParams,
    changeFilterByViaSearch,
  } = useContext(AppContext);

  return (
    <p className="breadcrumb text-capitalize text-start">
      <span
        className="dashboard_name_container"
        onClick={() => {
          navigate(`/${entityName}`);
          changeSelectedFilterByLabel(
            entityName === KEY_NAME.FUNDER ? "All publishers" : "All funders",
          );
          changeSelectedFilterBy("ALL");
          changeFilterByViaSearch(false);
          changeFilterBySearchParams(NO_SEARCH);
          changeFilterByData(null);
        }}
      >
        {entityName} Dashboard
      </span>
      &nbsp;/&nbsp;
      <span
        className={
          selectedFilterBy !== "ALL" && showFilter
            ? "entity_name_container"
            : ""
        }
        onClick={() => {
          if (!showFilter) return;
          changeSelectedFilterByLabel(
            entityName === KEY_NAME.FUNDER ? "All publishers" : "All funders",
          );
          changeSelectedFilterBy("ALL");
          changeFilterByViaSearch(false);
          changeFilterBySearchParams(NO_SEARCH);
        }}
      >
        {get(SEARCH_PARAMS.ENTITY_NAME)}{" "}
      </span>
      {selectedFilterBy !== "ALL" && showFilter && (
        <span>&nbsp;/&nbsp;{selectedFilterByLabel?.trim()}</span>
      )}
    </p>
  );
};

export default HeaderNavigate;
